import React from 'react';
import {
	MenuNodeType,
	type MenuItemNodeArgs,
} from '@atlassian/jira-software-context-menu/src/common/types.tsx';
import { ContextMenuItem } from '@atlassian/jira-software-context-menu/src/ui/menu-renderer/context-menu-inner/context-menu-node/context-menu-item/index.tsx';
import { useRemoveIssuesFromAllVersionsMutation } from '../../../../../../../../common/hooks/use-remove-issues-from-all-versions-mutation';
import type { CardId } from '../../../../../../../../model/types';
import { VERSION_MENU_ID } from '../../../../constants';

export type Props = {
	selectedCardIds: CardId[];
	menuItemNodeArgs: MenuItemNodeArgs;
	label: string;
};

export const UnlinkMenuItem = ({ selectedCardIds, label, menuItemNodeArgs }: Props) => {
	const removeIssuesFromAllVersions = useRemoveIssuesFromAllVersionsMutation();

	return (
		<ContextMenuItem
			{...menuItemNodeArgs}
			menuItem={{
				type: MenuNodeType.Item,
				id: `${VERSION_MENU_ID}/menu/value__unlink`,
				label,
				onClick: (analyticsEvent) => {
					removeIssuesFromAllVersions(selectedCardIds, analyticsEvent);
				},
			}}
		/>
	);
};
